import React from 'react'
import { useCountUp, UseCountUpOptions } from '../hooks/useCountUp'

export interface CountUpProps extends UseCountUpOptions {
  /** Target value to count to. Changing it re-animates from the current value. */
  value: number
  /** Formats the animated value for display. Default: rounded, locale-grouped integer. */
  format?: (value: number) => React.ReactNode
  className?: string
  style?: React.CSSProperties
}

const defaultFormat = (value: number) => Math.round(value).toLocaleString()

/**
 * Renders a number that counts up (or down) to `value` whenever it changes. Generic — drop it
 * anywhere a number is shown; pass `format` for decimals / currency / units.
 */
const CountUp: React.FC<CountUpProps> = ({ value, format = defaultFormat, className, style, ...options }) => {
  const current = useCountUp(value, options)
  return (
    <span className={className} style={style}>
      {format(current)}
    </span>
  )
}

export default CountUp
